import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';
import Tooltip from '@adsk/alloy-react-tooltip';

import {
  StyledPackagesSearchFilterButton,
  StyledSearchFilterButton,
  StyledClearSearchFilterButton,
} from './PackagesSearchFilterButton.styles';
import { usePackagesSearchFilter } from './PackagesSearchFilterProvider';
import getFilterCount from '../helpers/getFilterCount';
import getSearchCount from '../helpers/getSearchCount';

const PackagesSearchFilterButton = ({
  disabled,
  filtersOpen,
  onClick,
  filters,
  clearFilters,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { setPanelSearch, setPanelFilters } = usePackagesSearchFilter();
  const { searchExpression, ...panelFilters } = filters;

  const searchFilterCount =
    getSearchCount(searchExpression) + getFilterCount(panelFilters);

  const handleClearSearchFilter = () => {
    setPanelSearch('');
    setPanelFilters(() => ({}));
    clearFilters();
  };

  return (
    <StyledPackagesSearchFilterButton>
      <StyledSearchFilterButton
        disabled={disabled}
        selected={filtersOpen}
        onClick={onClick}
      >
        {T.translate('BUTTON.SEARCH_FILTER', { context: searchFilterCount })}
      </StyledSearchFilterButton>
      {!!searchFilterCount && (
        <Tooltip content={T.translate('BUTTON.CLEAR_SEARCH_FILTER')}>
          <StyledClearSearchFilterButton onClick={handleClearSearchFilter} />
        </Tooltip>
      )}
    </StyledPackagesSearchFilterButton>
  );
};

PackagesSearchFilterButton.propTypes = {
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * Whether or not filter panel is open.
   */
  filtersOpen: PropTypes.bool.isRequired,
  /**
   * Disable button functionality
   */
  disabled: PropTypes.bool,
  /**
   * Callback to clear filters.
   */
  clearFilters: PropTypes.func,
  /**
   * Callback to toggle filter panel open/close.
   */
  onClick: PropTypes.func.isRequired,
};

export default PackagesSearchFilterButton;
